import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { COLORS, BTN_GOLD_STYLE } from './theme';
import Shimmer from './Shimmer';
import { trackEvent } from '../../utils/analytics';

// Bottom bar (all viewports, per design): appears once the hero is scrolled
// past, hides while the register form is on screen and after signup.
const StickyCTA: React.FC = () => {
  const [heroVisible, setHeroVisible] = useState(true);
  const [formVisible, setFormVisible] = useState(false);
  const [registered, setRegistered] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    const form = document.getElementById('register');
    if (!hero || !form) return;

    const heroObserver = new IntersectionObserver(
      ([entry]) => setHeroVisible(entry.isIntersecting),
      { threshold: 0.15 }
    );
    const formObserver = new IntersectionObserver(
      ([entry]) => setFormVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    heroObserver.observe(hero);
    formObserver.observe(form);

    const onRegistered = () => setRegistered(true);
    window.addEventListener('paathshaala:registered', onRegistered);

    return () => {
      heroObserver.disconnect();
      formObserver.disconnect();
      window.removeEventListener('paathshaala:registered', onRegistered);
    };
  }, []);

  const show = !heroVisible && !formVisible && !registered;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: '110%' }}
          animate={{ y: 0 }}
          exit={{ y: '110%' }}
          transition={{ duration: 0.55, ease: [0.22, 0.61, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[60] flex justify-center px-4 pt-3 pb-[calc(12px+env(safe-area-inset-bottom,0px))]"
          style={{
            background:
              'linear-gradient(0deg, rgba(200,182,144,0.97), rgba(214,196,158,0.94))',
            borderTop: `1px solid ${COLORS.goldLeaf}`,
            boxShadow: '0 -12px 32px -10px rgba(26,15,10,0.35)',
          }}
        >
          <button
            onClick={() => {
              trackEvent('paathshala_cta_sticky_click', {});
              document
                .getElementById('register')
                ?.scrollIntoView({ behavior: 'smooth' });
              window.setTimeout(() => {
                document.getElementById('reg-email')?.focus({ preventScroll: true });
              }, 850);
            }}
            className="relative overflow-hidden inline-flex items-center justify-center w-full max-w-[480px] px-[30px] py-3 cursor-pointer transition-transform duration-300 active:scale-[0.98]"
            style={{ ...BTN_GOLD_STYLE, minHeight: '50px' }}
          >
            <Shimmer />
            Register for access
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
